import * as React from 'react';

import { cn } from '@rematter/ui-web';

import { SalesOrderRecord } from '../../types/salesOrder';
import { LoadsTab } from '../_shared/LoadsTab/LoadsTab';

type Props = {
  salesOrder: SalesOrderRecord;
  disableAddLoad?: boolean;
  variant?: 'default' | 'embedded';
};

export const SalesOrderTabLoads: React.FC<Props> = ({
  salesOrder,
  disableAddLoad = false,
  variant = 'default',
}) => (
  <LoadsTab
    className={cn('@SalesOrderTabLoads', variant === 'embedded' && 'p-0')}
    salesOrderId={salesOrder.id}
    entityType="salesOrder"
    disableAddLoad={disableAddLoad}
  />
);
